export default __webpack_public_path__ + "static/media/career.8dfa791d.svg";